
import { createContext } from 'react'

const QueriesCtx = createContext({
  query: { name: '', is_merge: false },
})

export default QueriesCtx
